module.exports = __webpack_public_path__ + "img/68.4b2ac86f.jpg";